export default {
    common: {
        title: "Bewerk Afbeelding",
        cancel: "Annuleren",
        save: "Opslaan",
        crop: "Oogst",
        adjustments: "Aanpassingen",
        filters: "Filters",
        frames: "Frames",
        overlays: "Overlay",
        text: "Tekst",
        stickers: "Stickervellen",
        brush: "Borstel",
        ai: "Maak een afbeelding met behulp van AI",
        reset: "Reset",
        comingSoon: 'Binnenkort beschikbaar...',
    },
};
